// extracted by mini-css-extract-plugin
export default {"questionContent":"interest_questions_section-module___questionContent___b944cfc3"};